export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '时间',
		align: 'center',
		dataIndex: 'orderDt',
		scopedSlots: { customRender: 'orderDt' },
	},
	{
		title: '总订单数',
		align: 'center',
		dataIndex: 'dispatchSucSum',
	},
	{
		title: '总完成订单数',
		align: 'center',
		dataIndex: 'finishSum',
	},
	{
		title: '总超时订单数',
		align: 'center',
		dataIndex: 'overTimeSum',
	},
	{
		title: '总审核退回订单数',
		align: 'center',
		dataIndex: 'lastBackSum',
	},
	{
		title: '今日新增订单数',
		align: 'center',
		dataIndex: 'dispatchSucNum',
	},
	{
		title: '今日完成订单数',
		align: 'center',
		dataIndex: 'finishNum',
	},
	{
		title: '今日超时订单数',
		align: 'center',
		dataIndex: 'overTimeNum',
	},
	{
		title: '今日审核退回订单数',
		align: 'center',
		dataIndex: 'lastBackNum',
	},
]
